import styled from 'styled-components';
import { mediaQuery, paddings } from '~/styled/GlobalStyles';
import { fontSizes } from '~/styled';

export const ControlButtonCommandErrorTitleDiv = styled.div<{ $centerAlign?: boolean }>`
  padding: ${paddings.defaultPadding};
  display: flex;
  flex-direction: row;
  gap: ${paddings.medium2xPadding};
  color: ${({ theme }) => theme.colors.onSurface};
  justify-content: ${({ $centerAlign }) => ($centerAlign ? 'center' : 'start')};
  font-size: ${fontSizes.fontSizePrimary};
  font-weight: 700;
  width: 100%;
`;
export const ControlButtonCommandErrorBodyDiv = styled.div`
  color: ${({ theme }) => theme.colors.onSurface};
  font-size: ${fontSizes.fontSizeBody};
  line-height: ${paddings.medium2xPadding};
  margin: ${paddings.mediumPadding} ${paddings.hugePadding};
`;
export const ControlButtonCommandErrorFooterDiv = styled.div`
  margin: ${paddings.defaultPadding};
  flex-direction: row;
  display: flex;
  justify-content: end;
`;

export const LoaderWrapperDiv = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: center;
`;

export const ModalParagraphDiv = styled.div`
  color: ${({ theme }) => theme.colors.onSurface};
  margin: 0 ${paddings.defaultPadding};
  font-size: ${fontSizes.fontSizeBody};
  line-height: ${fontSizes.fontSizeHeader3};
`;

export const ModalAssetsUl = styled.ul`
  overflow-y: auto;
  ${mediaQuery.up.s`
  max-height: 50vh;
  `}
`;
